import axios from 'axios';
import store from '../store';
import { merge } from 'lodash';

import { getHeaders, checkResponse, handleError } from './httpHandlerHelper';

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_CORE_API
});

axiosInstance.interceptors.request.use(
  config => {
    store.commit('loading', true);
    return config;
  },
  error => {
    store.commit('loading', false);
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  response => {
    store.commit('loading', false);
    checkResponse(response);
    return response;
  },
  error => {
    store.commit('loading', false);
    handleError(error);
    return Promise.reject(error);
  }
);

export const CancelToken = axios.CancelToken;

export const get = (path, params = {}) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(path, { headers: getHeaders(), params })
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
};

export const getArrayBuffer = (path, params = {}) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(path, { headers: getHeaders(), params, responseType: 'arraybuffer' })
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
};

export const post = (path, data) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(path, data, { headers: getHeaders() })
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
};

export const postFormData = (path, data, config) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(path, data, merge({ headers: getHeaders('form-data') }, config))
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
};

export const patch = (path, data) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .patch(path, data, { headers: getHeaders() })
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
};

export const patchFormData = (path, data, config) => {
  data.set('_method', 'PATCH');

  return postFormData(path, data, config);
};

export const remove = path => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(path, { headers: getHeaders() })
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
};
